import React from 'react';
import { colors } from '~/constants/colors';

export const SmallXSvg = ({ fill }: { fill: string }) => {
  return (
    <svg height="15" viewBox="0 0 35 35" width="15" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path
          d="m16.556 14.324-.096-.095-3.39 3.39.096.096-.096.095 3.39 3.39.096-.095L29.88 34.429l3.39-3.39-13.324-13.324L33.27 4.39 29.88 1 16.556 14.324Z"
          fill="#FFF"
        />
        <path
          d="m3.5 3.5 26.918 27.846M3.514 31.36l26.89-27.874"
          stroke={fill ?? colors.crunchBerry}
          strokeLinecap="square"
          strokeWidth="5"
        />
      </g>
    </svg>
  );
};
